import { graphqlOperation } from "aws-amplify";
import { API } from "aws-amplify";
import { createChatMessage } from "../../graphql/ChatMessage/mutations";
import {
  listChatMessagesByRoom,
  listChatMessagesByRoomWithNextToken,
} from "../../graphql/ChatMessage/queries";
import { onCreateChatMessageRoomFilter } from "../../graphql/ChatMessage/subscriptions";
import { listNotificationsByUsernameAndStatus } from "../../graphql/Notification/queries";
import { onCreateNotifications } from "../../graphql/Notification/subscriptions";

export default class GraphQLManager {
  // Chat Messages

  async create(content, roomId, username) {
    const message = {
      author: username,
      content,
      roomId: roomId, 
    };
    let response = await API.graphql(
      graphqlOperation(createChatMessage, { input: message })
    );
  }

  subscribeForNewMessages(roomId, onMessage) {
    const subscription = API.graphql(
      graphqlOperation(onCreateChatMessageRoomFilter, { roomId: roomId })
    ).subscribe({
      next: (message) => {
        onMessage(message);
      },
    });

    return subscription;
  }

  async getMessagesForRoom(roomId, getCancel) {
    let messagesList = [];
    let nextToken = undefined;
    do {
      let promise = undefined;
      if (nextToken) {
        promise = API.graphql(
          graphqlOperation(listChatMessagesByRoomWithNextToken, {
            eq: roomId,
            nextToken,
          })
        );
      } else {
        promise = API.graphql(
          graphqlOperation(listChatMessagesByRoom, { eq: roomId })
        );
      }

      const apiResponse = await promise;
      nextToken = apiResponse?.data?.listChatMessages?.nextToken;
      messagesList = messagesList.concat(
        apiResponse?.data?.listChatMessages?.items
      );
    } while (nextToken !== null && nextToken !== undefined);

    return messagesList;
  }

  // Notifications

  async getNotificationsByUsernameAndStatus(username, status) {
    const items = await API.graphql(
      graphqlOperation(listNotificationsByUsernameAndStatus, {
        username,
        status,
      })
    );
    return items?.data?.listNotifications?.items;
  }

  subscribeForNewNotifications(username, onNotification) {
    const subscription = API.graphql(
      graphqlOperation(onCreateNotifications, { username: username })
    ).subscribe({
      next: (notification) => {
        onNotification(notification);
      },
    });

    return subscription;
  }
}
